// extracted by mini-css-extract-plugin
export var blog_content = "blogCard-module--blog_content--aVmut";
export var blog_content_text = "blogCard-module--blog_content_text--BKf2S";
export var blog_date = "blogCard-module--blog_date--olPdp";
export var blog_title = "blogCard-module--blog_title--WM9TS";
export var card = "blogCard-module--card--4Pz1U";
export var category_tag = "blogCard-module--category_tag--lnK5u";
export var category_text = "blogCard-module--category_text--OUrus";
export var content = "blogCard-module--content--5YT3y";
export var content_space = "blogCard-module--content_space--hkIyG";
export var image = "blogCard-module--image--WtiEk";
export var image_link = "blogCard-module--image_link--UmCp9";
export var padding_zero = "blogCard-module--padding_zero--1giBj";